export default __webpack_public_path__ + "static/media/sushi.577909b6.svg";